/** Grymwyrd 简体中文 翻译—共享布局的文案（顶部导航 + 页脚）。 */
export const layoutZhCN = {
  'layout.nav.veil': '幽境',
  'layout.nav.encyclopedia': '百科全书',
  'layout.nav.world': '世界',
  'layout.nav.play': '进入游戏',
  'layout.nav.books': '规则书',
  'layout.nav.community': '社群',
  'layout.nav.homeAria': '{world} 首页',
  'layout.nav.search': '搜索百科全书',
  'layout.nav.unmute': '启用背景音效',
  'layout.nav.mute': '关闭背景音效',
  'layout.nav.coinBalance': '金币余额',
  'layout.nav.signedInAs': '登录身份：{name}',
  'layout.nav.enter': '进入 {world}',
  'layout.nav.toggleMenu': '打开/关闭菜单',
  'layout.nav.dashboard': '我的 {world}（{name}）',
  'layout.nav.signOut': '登出',

  'layout.footer.hideLinks': '隐藏网站链接',
  'layout.footer.showLinks': '网站链接与法律信息',
  'layout.footer.tagline': '在这个活态恐怖奇幻世界里，你的传奇成为正史。',
  'layout.footer.explore': '探索',
  'layout.footer.legal': '法律',
  'layout.footer.accessibility': '无障碍访问',
  'layout.footer.encyclopedia': '百科全书',
  'layout.footer.world': '世界',
  'layout.footer.playVtt': '进入游戏（VTT）',
  'layout.footer.books': '规则书',
  'layout.footer.terms': '服务条款',
  'layout.footer.privacy': '隐私政策',
  'layout.footer.canonRelease': '正史投稿许可',
  'layout.footer.aiPolicy': 'AI 政策',
  'layout.footer.cookies': 'Cookie 偏好设置',
  'layout.footer.copyright': '© 2026 GameCodex',
}
